import { Injectable } from '@angular/core';
import { Globals } from '../../globals';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})

export class RemarkService {
    constructor(private global: Globals, private _httpClient: HttpClient) { }

    

    GetRemarkList() {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this._httpClient.get(this.global.G_apiUrl +'/remark/CounterByUser/'+
        this.global.loggedUser.user.user_reg_id,{headers:headers});
    }

    GetIndividualRemarkList(remarkId:any)
    {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this._httpClient.get(this.global.G_apiUrl +'/approvedEmail/approvedByRemark/'+
        this.global.loggedUser.user.user_reg_id+'/'+remarkId,{headers:headers});
    }
}